import {cn} from '@sollapay/ui';
import {ContentSection, Skeleton, Typography} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

const GRID_COLS = 'grid-cols-[repeat(8,1fr)_52px]';

export function PayoutsTabContentSkeleton() {
  const {t} = useTranslation('trustAccounts');
  const prefix = 'view.payouts.list';

  const headers = [
    t(`${prefix}.columns.beneficiary`),
    t(`${prefix}.columns.role`),
    t(`${prefix}.columns.purpose`),
    t(`${prefix}.columns.amount`),
    t(`${prefix}.columns.reference`),
    t(`${prefix}.columns.transferType`),
    t(`${prefix}.columns.status`),
    t(`${prefix}.columns.createdAt`)
  ];

  return (
    <ContentSection
      title={t('view.payouts.title')}
      subtitle={t('view.payouts.subtitle')}
      action={<Skeleton className="h-9 w-32 rounded-md" />}
    >
      <div className="overflow-hidden rounded-xl border border-border-subtle shadow-xs">
        <div
          className={cn(
            'grid gap-4 border-b border-border-subtle bg-background-surface px-4 py-3',
            GRID_COLS
          )}
        >
          {headers.map(label => (
            <Typography key={label} size="xs" color="tertiary">
              {label}
            </Typography>
          ))}
          <div />
        </div>
        {Array.from({length: 4}).map((_, i) => (
          <div
            key={i}
            className={cn(
              'grid items-center gap-4 border-b border-border-subtle px-4 py-3 last:border-b-0',
              GRID_COLS
            )}
          >
            <div className="flex items-center gap-2">
              <Skeleton className="size-8 shrink-0 rounded-full" />
              <Skeleton className="h-4 w-20" />
            </div>
            <Skeleton className="h-5 w-16 rounded-full" />
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-4 w-16" />
            <Skeleton className="h-5 w-20 rounded-full" />
            <Skeleton className="h-5 w-20 rounded-full" />
            <Skeleton className="h-5 w-20 rounded-full" />
            <Skeleton className="h-4 w-16" />
            <Skeleton className="size-8 rounded-md" />
          </div>
        ))}
      </div>
    </ContentSection>
  );
}
